import { GetterTree } from "vuex";

import {
    ICheckoutModel,
    IModelValidationRules,
    IOrderModel,
    IPromotionModel,
    IPropertyValidationRules,
    ISelectListItem,
    IValidationRules
} from "../../models";
import IAppState from "../IAppState";
import AppGetterTypes from "./AppGetterTypes";
import { GetPropertyValidationRules } from "./GetPropertyValidationRules";

const getters: GetterTree<IAppState, IAppState> = {
    [AppGetterTypes.version](state: IAppState): string | null | undefined {
        return state.version;
    },

    [AppGetterTypes.paymentMethods](state: IAppState): ISelectListItem[] {
        return state.paymentMethods;
    },

    [AppGetterTypes.validationRules](state): IValidationRules {
        return state.validationRules;
    },

    [AppGetterTypes.getModelValidationRules]: (state: IAppState) => (
        modelName: string
    ): IModelValidationRules => {
        return state.validationRules[modelName];
    },

    [AppGetterTypes.getPropertyValidationRules]: (state: IAppState) => (
        expression: string
    ): IPropertyValidationRules => {
        const rulesNameParts = expression.split(".");
        const modelType = rulesNameParts[0];
        const propertyName = rulesNameParts[1];

        return state.validationRules[modelType][propertyName];
    },

    [AppGetterTypes.promotion](state: IAppState): IPromotionModel | undefined {
        return state.promotion;
    },

    [AppGetterTypes.checkout](state: IAppState): ICheckoutModel | undefined {
        return state.checkout;
    },

    [AppGetterTypes.order](state: IAppState): IOrderModel | undefined {
        return state.order;
    },

    [AppGetterTypes.genericOrderFailedMessage](
        state: IAppState
    ): string | null | undefined {
        return state.genericOrderFailedMessage;
    },

    [AppGetterTypes.pageTitle](state: IAppState): string | undefined {
        return state.pageTitle;
    }
};

export default getters;

export { AppGetterTypes, GetPropertyValidationRules };
